import React from 'react';
import { graphql } from 'gatsby';
import FileRow from '../FileRow';
import clsx from 'clsx';
import { CommonSectionProps, SectionBgColor } from '../../templates/Page';
import { areSameFlatColor } from '../../utils/utils';

import * as styles from './ResourceFileListSection.module.scss';

export const ResourceFileListSectionFragment = graphql`
  fragment ResourceFileListSection on SanityResourceFileListSection {
    title
    resourceFiles {
      ...ResourceFile
    }
  }
`;

export type ResourceFileListSectionProps = {
  title?: string;
  resourceFiles: Array<{
    title: string;
    file: {
      asset: {
        size: number;
        url: string;
      };
    };
  }>;
  className?: string;
};

export function getSectionBgColor(props: ResourceFileListSectionProps): SectionBgColor<'white'> {
  return {
    name: 'white',
    type: 'solid',
  };
}

function ResourceFileListSection<PrevSectionColorName extends string>(
  props: ResourceFileListSectionProps & CommonSectionProps<PrevSectionColorName>,
): React.ReactElement {
  const { title, resourceFiles, className, previousSectionBgColor } = props;

  return (
    <section
      id={props.sectionID || ''}
      className={clsx(
        styles.sectionContainer,
        className,
        areSameFlatColor(getSectionBgColor(props), previousSectionBgColor) && styles.noPaddingTop,
      )}
    >
      <div className={styles.section}>
        {title && <h2 className={styles.title}>{title}</h2>}
        {resourceFiles.map((resourceFile, i) => (
          <FileRow
            key={i}
            title={resourceFile.title}
            size={resourceFile.file.asset.size}
            url={resourceFile.file.asset.url}
          />
        ))}
      </div>
    </section>
  );
}

export default ResourceFileListSection;
